<template>
  <div class="page-container">
    <header class="nudge-pay-header">
      <img src="@/assets/images/logo/tracking-logo.png" alt="Nudg Pay Logo" />
    </header>

    <div
      v-show="activeBookingDiv || dispatchedBookingDiv || advancedBookingDiv"
      class="booking-details-container"
    >
      <div class="booking-details-card">
        <div class="booking-status-row">
          <h3 class="booking-title">Booking Details</h3>
          <button :class="statusButtonClass">
            {{
              bookingStatus === "active"
                ? "Searching"
                : bookingStatus === "booked"
                ? "Advance"
                : capitalizeFirstLetter(bookingStatus)
            }}
          </button>
        </div>
        <div v-show="activeBookingDiv" class="searching-box">
          <span class="search-icon">
            <img
              class="search-icon-img"
              src="@/assets/images/search.png"
              alt="Searching Icon"
            />
          </span>
          <div class="searching-text">We’re Searching Nearby Driver</div>
        </div>

        <div v-show="activeBookingDiv || advancedBookingDiv">
          <div class="vehicle-info-row">
            <p>Price</p>
            <p>
              <strong>  £ {{ bookingInfo.price }} {{ cashMeterJob? 'Approx.' : '' }}</strong>
            </p>
          </div>
          <div class="vehicle-info-row">
            <p>Date & Time</p>
            <p>
              <strong>{{ bookingInfo.bookedAtTime }}</strong>
            </p>
          </div>
          <div class="vehicle-info-row">
            <p>Payment</p>
            <p class="payment-color">{{ bookingInfo.paymentType }}/{{bookingInfo.paymentStatus}}</p>
          </div>
        </div>
        <div v-show="dispatchedBookingDiv">
          <div class="booking-details-header">
            <div class="driver-info">
              <img
                class="driver-avatar"
                src="@/assets/images/driver.png"
                alt="Driver Avatar"
              />
              <div class="driver-details">
                <p class="driver-name">{{ driverInfo.name }}</p>
                <div class="driver-rating">
                  <img
                    class="star-icon"
                    src="@/assets/images/star-favorite.png"
                    alt="Star Icon"
                  />
                  <span class="ml-1">{{ driverInfo.rating }}</span>
                </div>
              </div>
            </div>
            <div class="driver-actions">
              <button class="contact-button" @click.prevent="callDriver()">
                <img src="@/assets/images/phone-icon.png" alt="Call Driver" />
              </button>
              <!-- <button class="share-button" @click.prevent="shareContent()">
                <img src="@/assets/images/share-icon.png" alt="Share Info" />
              </button> -->
            </div>
          </div>

          <div class="vehicle-info-row">
            <p>{{ carInfo.name }} - {{ carInfo._color }}</p>
            <p class="license-plate">{{ carInfo.numberPlate }}</p>
          </div>

          <div class="ride-info-row">
            <div v-show="showETA" class="eta">
              <p class="ride-info-heads">ETA</p>
              <p>
                <strong>{{bookingInfo.eta }}</strong>
              </p>
            </div>
            <div class="distance">
              <p class="ride-info-heads">Distance</p>
              <p>
                <strong>{{ bookingInfo.distance }} mi</strong>
              </p>
            </div>
            <div class="price">
              <p class="ride-info-heads">Price</p>
              <p>
                <strong>£ {{ bookingInfo.price }} {{ cashMeterJob? 'Approx.' : '' }}</strong>
              </p>
            </div>
          </div>
        </div>

        <div class="locations">
          <div class="location-row">
            <div class="pickup-row">
              <span class="location-icon">
                <img
                  class="location-icon-img"
                  src="@/assets/images/blue-circle.png"
                  alt="Pickup Icon"
                />
              </span>
              <span class="location-type">Pickup</span>
              <span class="separator">|</span>
              <span class="location-address">{{ bookingInfo.pickup }}</span>
            </div>
          </div>

          <div class="location-row">
            <div class="dropoff-row">
              <span class="location-icon">
                <img
                  class="location-icon-img"
                  src="@/assets/images/green-vector.png"
                  alt="Dropoff Icon"
                />
              </span>
              <span class="location-type">Dropoff</span>
              <span class="separator">|</span>
              <span class="location-address">{{
                bookingInfo.destination
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="map-container">
        <GmapMap
          :center="mapCenter"
          :zoom="mapZoom"
          ref="gmap"
          style="width: 100%; height: 500px; border-radius: 15px"
          :options="mapOptions"
        >
          <GmapMarker 
            v-if="origin && PickupIcon" 
            :position="origin"
            :icon="PickupIcon"
            :label="{
              text: 'PICKUP',
              color: '#0066CC',
              fontSize: '11px',
              fontWeight: '700',
              className: 'pickup-marker-label'
            }"
            :zIndex="1000"
          ></GmapMarker>
          <GmapMarker
            v-if="destination && DestinationIcon"
            :position="destination"
            :icon="DestinationIcon"
            :label="{
              text: 'DROPOFF',
              color: '#4CAF50',
              fontSize: '11px',
              fontWeight: '700',
              className: 'dropoff-marker-label'
            }"
            :zIndex="1000"
          ></GmapMarker>
          <GmapMarker
            v-if="vehicleAssigned && vehiclePosition && vehiclePosition.lat != null && vehiclePosition.lng != null && !isNaN(vehiclePosition.lat) && !isNaN(vehiclePosition.lng)"
            :icon="carIcon"
            :position="vehiclePosition"
          ></GmapMarker>
          <GmapPolyline
            v-if="route"
            :path="route"
            strokeColor="#0000FF"
            strokeOpacity="1.0"
            strokeWeight="2"
          ></GmapPolyline>
        </GmapMap>
      </div>
    </div>
    <div v-show="archivedBookingDiv">
      <div class="h-screen flex w-full bg-img">
        <div
          class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
        >
          <img
            src="@/assets/images/pages/404.png"
            alt="graphic-404"
            class="mx-auto mb-4 max-w-full"
          />
          <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
            404 - Page Not Found!
          </h1>
          <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse">
            The Booking you are looking for is not available for tracking
          </p>
        </div>
      </div>
    </div>
    <div v-show="trackingFeatureDisabled" class="feature-disabled-wrap">
      <div class="feature-disabled-card">
        <img
          src="@/assets/images/pages/404.png"
          alt="feature-not-enabled"
          class="feature-disabled-img"
        />
        <h1 class="feature-disabled-title">
          Tracking Unavailable
        </h1>
        <p class="feature-disabled-text">
          This feature is not enabled for its admin.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { WEB_SERVER_HOST } from "@/environment/index";
import { createEcho } from "@/plugins/echo";

window.Echo = createEcho({
  host: WEB_SERVER_HOST,
  authEndpoint: "/broadcasting/auth",
});

import { ride_details, locate_vehicle, calculate_eta } from "@/services/Tracking";

export default {
  name: "LiveTracking",

  data() {
    return {
      bid: this.$route.params.bid,
      sysdomain: this.$route.params.sysdomain,
      apiBookingId: null,
      bookingData: {},
      provider : null,

      // map data start
      mapCenter: { lat: 52.954783, lng: -1.158109 }, // Center of Nottingham as an example
      origin: null,
      destination: null,
      route: null,
      mapOptions: {
        mapTypeId: "roadmap",
      },

      // map data ends
      bookingInfo: {
        bookedAtTime: null,
        pickupDateTime: "",
        price: "",
        eta: "",
        distance: "",
        pickup: "",
        destination: "",
        paymentType: "Cash",
        systemId: null,
      },
      pickupText: "",
      destinationText: "",
      driverInfo: {
        name: "",
        rating: "0.0",
        phone: "",
        photo: "",
      },
      carInfo: {
        numberPlate: "",
        _color: "",
        name: "",
      },

      bookingStatus: "",
      directionsService: null,
      directionsDisplay: null,
      mapZoom: 10, // Default zoom level


      lastPosition: {},
      numDeltas: 100,
      delay: 10, // milliseconds
      i: 0,

      activeBookingDiv: false,
      archivedBookingDiv: false,
      dispatchedBookingDiv: false,
      advancedBookingDiv: false,

      vehiclePosition: {
        lat: null,
        lng: null,
        heading: 0,
      },
      newVehiclePositionDestination: null, // Target destination to move towards

      DestinationIcon: null,
      PickupIcon: null,
      vehicleAssigned: false,
      vehicleId: null,
      vehicleConnectionSetup:false,
      getVehiclePositionCalled: false,
      paymentStatus: 'UnPaid',
      // Will be initialised as a custom teardrop marker in initMarkers()
      carIcon: null,
      // Local ETA calculation state (no external APIs)
      lastEtaPoint: null,
      lastEtaTime: null,
      etaSpeedKmh: 30, // default fallback speed in km/h
      showETA: true,
      // Autocab ETA API (simple throttle)
      autocabEtaLoading: false,
      autocabEtaLastFetchAt: 0,
      a: null,
      b:null,
      bookingChannelId: null, // currently connected booking channel id
      vehicleChannelId: null, // currently connected vehicle channel id
      cashMeterJob: false,
      trackingFeatureDisabled: false,
   };
  },
  computed: {
    statusButtonClass() {
      const statusClasses = {
        dispatched: "accepted-button",
        pickedup: "accepted-button",
        arrived: "accepted-button",
        complete: "accepted-button",
        booked: "advance-button",
        active: "advance-button",
        offered: "advance-button",
        searching: "searching-status-btn",
        archived: "archived-button",
        cancelled: "archived-button",
      };
      return statusClasses[this.bookingStatus] || "default-button";
    },
  },

  mounted() {
    document.title = "Nudg Tracking";
    const favicon = document.getElementById("favicon");

    if (favicon) {
      favicon.href =  `${process.env.BASE_URL}nudgtrack-favicon.ico`;//require("@/assets/images/logo/nudgtrack-favicon.ico");
    }
    this.initMap();
  },

  beforeDestroy() {
    // Clean up socket connections when component is destroyed
    if (this.apiBookingId) {
      window.Echo.leave(`booking.${this.apiBookingId}`);
    }
    if (this.vehicleId) {
      window.Echo.leave(`booking-vehicle.${this.vehicleId}`);
    }
  },
  watch: {
    // Watch for changes in bookingStatus
    bookingStatus(newStatus) {
      // Set showETA to false for certain statuses
      if (["pickedup", "arrived", "complete", "completed"].includes(newStatus)) {
        this.showETA = false;
      }
      else {
        this.showETA = true;
      }
      if(newStatus == 'complete')
        this.leaveChannel('vehiclePosition');

    // Reset all booking div states to false
      this.dispatchedBookingDiv = false;
      this.activeBookingDiv = false;
      this.archivedBookingDiv = false;
      this.advancedBookingDiv = false;

      // Update the specific div based on the new status
      switch (newStatus) {
        case "active":
        case "offered": 
          this.activeBookingDiv = true;
          break;
        case "cancelled":
        case "complete":
        case "completed":
          if(this.vehicleConnectionSetup) {
            this.leaveChannel('vehiclePosition');
          }
          this.redirectToPreviousPage();

          this.archivedBookingDiv = true;
          break;
        case "booked":
          this.advancedBookingDiv = true;
          break;
        case "dispatched":
        case "arrived":
        case "pickedup":

          if(!this.getVehiclePositionCalled && this.vehicleId)
            {this.getVehiclePosition();}
          this.dispatchedBookingDiv = true;
          this.vehicleAssigned = true;
          break;
        default:
          console.log('defaulter case of booking status');
          break;
      }
    },
  },
  methods: {
    redirectToPreviousPage() {
      const sysdomain = this.sysdomain || this.$route.params.sysdomain;
      const bid = this.bid || this.$route.params.bid;

      if (sysdomain && bid) {
        this.$router.push({
          name: "SmsPayment",
          params: { sysdomain, bid },
        }).catch(() => {});
        return;
      }

      // Fallback: strip /live-track from the current URL
      const urlWithoutLiveTrack = window.location.href.replace('/live-track', '');
      window.location.href = urlWithoutLiveTrack;
    },
    leaveChannel(channelName) {
        if(channelName == 'vehiclePosition') {
          this.vehicleAssigned = false;
          window.Echo.leave(`booking-vehicle.${this.vehicleId}`);
        }
    },
    getVehiclePosition(){
      locate_vehicle(this.apiBookingId,this.vehicleId,this.bookingInfo.systemId).then(res => {
        this.getVehiclePositionCalled = true;
        this.setInitialPosition(res.data);
        if(!this.vehicleConnectionSetup) {
          this.setupSocketConnectionForVehicle(this.vehicleId);
        }
      });
    },

    initMap() {
      this.$vs.loading({ text: "Fetching data......" });
      this.initMarkers();
      this.fetchRideDetails();
    },

    initMarkers() {
      // Create custom teardrop pin markers like the image
      if (typeof google === "undefined" || !google.maps || !google.maps.SymbolPath) {
        // Fallback if Google Maps not loaded yet
        setTimeout(() => this.initMarkers(), 100);
        return;
      }

      // Pickup marker - Darker blue teardrop with location pin icon
      this.PickupIcon = this.createTeardropMarker('#0066CC', 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z');

      // Dropoff marker - Darker green teardrop with person icon
      this.DestinationIcon = this.createTeardropMarker('#4CAF50', 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z');

      // Car marker - Use car.svg directly as the marker icon
      const carSvgUrl = require('@/assets/car.svg');
      this.carIcon = {
        url: carSvgUrl,
        scaledSize: new google.maps.Size(50, 19),
        anchor: new google.maps.Point(25, 9.5),
      };
    },

    createTeardropMarker(color, iconPath) {
      // Ensure Google Maps is loaded
      if (typeof google === "undefined" || !google.maps || !google.maps.Size || !google.maps.Point) {
        console.warn('Google Maps not loaded yet, using fallback marker format');
        // Return a simple format that doesn't require google.maps
        const uniqueId = 'marker-' + Math.random().toString(36).substr(2, 9);
        const svg = `<svg width="48" height="64" viewBox="0 0 48 64" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <filter id="shadow-${uniqueId}" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
              <feOffset dx="0" dy="2" result="offsetblur"/>
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.3"/>
              </feComponentTransfer>
              <feMerge>
                <feMergeNode/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          <path d="M24 0C10.74 0 0 10.74 0 24c0 8.5 5.5 16.5 13 22.5L24 64l11-17.5c7.5-6 13-14 13-22.5C48 10.74 37.26 0 24 0z" 
                fill="${color}" 
                filter="url(#shadow-${uniqueId})"
                stroke="#FFFFFF"
                stroke-width="1.5"/>
          <g transform="translate(12, 10)">
            <path d="${iconPath}" 
                  fill="#FFFFFF" 
                  fill-opacity="1"
                  stroke="none"/>
          </g>
        </svg>`;
        const encodedSvg = encodeURIComponent(svg);
        const dataUri = `data:image/svg+xml;charset=utf-8,${encodedSvg}`;
        return {
          url: dataUri,
          scaledSize: { width: 48, height: 64 },
          anchor: { x: 24, y: 64 },
          labelOrigin: { x: 24, y: 72 }
        };
      }

      // Create a teardrop pin shape SVG with icon inside
      const uniqueId = 'marker-' + Math.random().toString(36).substr(2, 9);
      const svg = `<svg width="48" height="64" viewBox="0 0 48 64" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <filter id="shadow-${uniqueId}" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
              <feOffset dx="0" dy="2" result="offsetblur"/>
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.3"/>
              </feComponentTransfer>
              <feMerge>
                <feMergeNode/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          <path d="M24 0C10.74 0 0 10.74 0 24c0 8.5 5.5 16.5 13 22.5L24 64l11-17.5c7.5-6 13-14 13-22.5C48 10.74 37.26 0 24 0z" 
                fill="${color}" 
                filter="url(#shadow-${uniqueId})"
                stroke="#FFFFFF"
                stroke-width="1.5"/>
          <g transform="translate(12, 10)">
            <path d="${iconPath}" 
                  fill="#FFFFFF" 
                  fill-opacity="1"
                  stroke="none"/>
          </g>
        </svg>`;

      // Convert SVG to data URI for better compatibility
      const encodedSvg = encodeURIComponent(svg);
      const dataUri = `data:image/svg+xml;charset=utf-8,${encodedSvg}`;

      return {
        url: dataUri,
        scaledSize: new google.maps.Size(48, 64),
        anchor: new google.maps.Point(24, 64),
        labelOrigin: new google.maps.Point(24, 72) // Position label below the marker
      };
    },

    createTeardropMarkerWithImage(color, imageUrl) {
      // Create a teardrop pin shape SVG with car image embedded
      // Use the imageUrl directly - webpack will handle the path
      const uniqueId = 'marker-' + Math.random().toString(36).substr(2, 9);
      
      // Ensure Google Maps is loaded
      if (typeof google === "undefined" || !google.maps || !google.maps.Size || !google.maps.Point) {
        console.warn('Google Maps not loaded yet, using fallback marker format');
        const svg = `<svg width="48" height="64" viewBox="0 0 48 64" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <filter id="shadow-${uniqueId}" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
              <feOffset dx="0" dy="2" result="offsetblur"/>
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.3"/>
              </feComponentTransfer>
              <feMerge>
                <feMergeNode/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          <path d="M24 0C10.74 0 0 10.74 0 24c0 8.5 5.5 16.5 13 22.5L24 64l11-17.5c7.5-6 13-14 13-22.5C48 10.74 37.26 0 24 0z" 
                fill="${color}" 
                filter="url(#shadow-${uniqueId})"
                stroke="#FFFFFF"
                stroke-width="1.5"/>
          <image xlink:href="${imageUrl}" x="6" y="6" width="36" height="28" preserveAspectRatio="xMidYMid meet"/>
        </svg>`;
        const encodedSvg = encodeURIComponent(svg);
        const dataUri = `data:image/svg+xml;charset=utf-8,${encodedSvg}`;
        return {
          url: dataUri,
          scaledSize: { width: 48, height: 64 },
          anchor: { x: 24, y: 64 },
          labelOrigin: { x: 24, y: 72 }
        };
      }

      const svg = `<svg width="48" height="64" viewBox="0 0 48 64" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <filter id="shadow-${uniqueId}" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
              <feOffset dx="0" dy="2" result="offsetblur"/>
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.3"/>
              </feComponentTransfer>
              <feMerge>
                <feMergeNode/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          <path d="M24 0C10.74 0 0 10.74 0 24c0 8.5 5.5 16.5 13 22.5L24 64l11-17.5c7.5-6 13-14 13-22.5C48 10.74 37.26 0 24 0z" 
                fill="${color}" 
                filter="url(#shadow-${uniqueId})"
                stroke="#FFFFFF"
                stroke-width="1.5"/>
          <image xlink:href="${imageUrl}" x="6" y="6" width="36" height="28" preserveAspectRatio="xMidYMid meet"/>
        </svg>`;

      // Convert SVG to data URI for better compatibility
      const encodedSvg = encodeURIComponent(svg);
      const dataUri = `data:image/svg+xml;charset=utf-8,${encodedSvg}`;

      return {
        url: dataUri,
        scaledSize: new google.maps.Size(48, 64),
        anchor: new google.maps.Point(24, 64),
        labelOrigin: new google.maps.Point(24, 72)
      };
    },

    setVehicleId(id) {
      this.vehicleId = id;
    },

    setVehiclePosition(position) {
      // Handle both lat/lng and latitude/longitude formats
      const lat = parseFloat(position.lat || position.latitude);
      const lng = parseFloat(position.lng || position.longitude);
      
      if (isNaN(lat) || isNaN(lng)) {
        console.error('Invalid position data:', position);
        return;
      }
      
      this.vehiclePosition.lat = lat;
      this.vehiclePosition.lng = lng;
      this.vehiclePosition.heading = position.heading || 0;
    },

    setZoomBasedOnDistance() {
      // Check if Google Maps is loaded
      if (typeof google === "undefined" || !google.maps || !google.maps.LatLng || !google.maps.geometry) {
        return;
      }
      
      const originLatLng1 = new google.maps.LatLng(
        this.origin.lat,
        this.origin.lng
      );
      const destinationLatLng1 = new google.maps.LatLng(
        this.destination.lat,
        this.destination.lng
      );
      const distanceInMeters =
        google.maps.geometry.spherical.computeDistanceBetween(
          originLatLng1,
          destinationLatLng1
        );
      // Adjust zoom based on the calculated distance (you can fine-tune these numbers)
      if (distanceInMeters < 500) {
        this.mapZoom = 16; // For very short distances
      } else if (distanceInMeters < 3000) {
        this.mapZoom = 15; // Short distances
      }  else if (distanceInMeters < 5000) {
        this.mapZoom = 14; // Short distances
      } else if (distanceInMeters < 20000) {
        this.mapZoom = 12; // Short distances
      } else if (distanceInMeters < 50000) {
        this.mapZoom = 10; // Medium distances
      } else {
        this.mapZoom = 8; // Long distances
      }

      // Center the map between the two markers
      this.mapCenter = {
        lat: (this.origin.lat + this.destination.lat) / 2,
        lng: (this.origin.lng + this.destination.lng) / 2,
      };
    },

    formatTime(estimatedTime) {
      // Split the time string by colon to extract hours, minutes, seconds, and milliseconds
      let [hours, minutes, seconds] = estimatedTime.split(":");

      // Further split seconds to separate the milliseconds (if needed)
      seconds = seconds.split(".")[0]; // Get rid of the milliseconds part

      // Convert hours, minutes, and seconds to numbers
      hours = parseInt(hours, 10);
      minutes = parseInt(minutes, 10);
      seconds = parseInt(seconds, 10);

      // Create a readable string based on the available data
      let humanReadable = "";
      if (hours > 0) {
        humanReadable += `${hours} hour${hours > 1 ? "s" : ""} `;
      }
      if (minutes > 0) {
        humanReadable += `${minutes} minute${minutes > 1 ? "s" : ""} `;
      }
      if (seconds > 0) {
        humanReadable += `${seconds} second${seconds > 1 ? "s" : ""}`;
      }

      return humanReadable.trim();
    },

    ensureMinutes(eta) {
      if (eta === null || eta === undefined) {
        return "";
      }

      const text = String(eta).trim();
      if (!text) {
        return "";
      }

      // If ETA already includes any time unit (minutes, seconds, hours, etc.)
      if (/\b(minutes?|min?|minute?|secs?|seconds?|hours?|hrs?|days?)\b/i.test(text) || /[a-zA-Z]/.test(text)) {
        return text;
      }

      // Otherwise treat the value as raw minutes and append the unit.
      return `${text} minutes`;
    },


    fetchRideDetails() {
      ride_details(this.bid)
        .then((response) => {
          if (response.data.obj == null) {
            // means we've archived booking
            this.$vs.loading.close();
            this.dispatchedBookingDiv = false;
            this.activeBookingDiv = false;
            this.$router.push("/p/"+this.sysdomain+"/"+this.bid).catch(() => {});

            // this.archivedBookingDiv = true;
            return;
          }

          const features = response.data.obj.features || [];
          if (!features.includes('nudgpay_tracking')) {
            this.$vs.loading.close();
            this.trackingFeatureDisabled = true;
            return;
          }

          this.apiBookingId = response.data.obj.api_booking_Id;
          const data = response.data.obj.booking;
          const responseObj = response.data.obj;
          this.provider = response.data.obj.booking_provider;
          this.bookingData = data;

          this.setupSocketConnectionForBookingStatus(this.apiBookingId);
          this.bookingStatus = responseObj.booking_status;
          this.bookingInfo.pickup = responseObj.pickup;
          this.bookingInfo.destination = responseObj.destination;
          this.bookingInfo.price = responseObj.price;
          this.bookingInfo.distance = responseObj.distance;
          this.bookingInfo.pickupDateTime = responseObj.pickup_due_time;
          // this.bookingInfo.eta = this.ensureMinutes(responseObj.eta);
          this.bookingInfo.bookedAtTime = responseObj.bookedAtTime;
          this.bookingInfo.paymentType = responseObj.paymentType;
          this.bookingInfo.paymentStatus = responseObj.paymentType == 'Account' ? 'Paid' : this.capitalizeFirstLetter(responseObj.payment_status);
          this.bookingInfo.systemId = responseObj.system_id ? responseObj.system_id : null;

          if(this.provider == 'infocab') {
            if(data.pricing.fareType == 'Meter'){
              this.cashMeterJob = true;
            }
          }
          // if booking status is not active
          this.driverInfo.name = responseObj.driver_name;
          this.driverInfo.phone = responseObj.driver_mobile;
          this.driverInfo.rating = responseObj.driver_rating;
          this.carInfo._color = responseObj.vehicle_color;
          this.carInfo.numberPlate = responseObj.vehicle_registration;
          this.carInfo.name = responseObj.vehicle_name;
          

          if (
            this.bookingStatus != "active" &&
            this.bookingStatus != "booked" &&
            this.bookingStatus != "offered"
          ) {
            if(this.provider === 'infocab') {
              this.vehicleId = responseObj.vehicle.infocab_vehicle_id;
            }
            else if(this.provider === 'autocab') {
              this.vehicleId = responseObj.vehicle.id;
            }
            else {
              this.vehicleId = null;
            }
          }

          const pickupLat = data.pickup.address.coordinate.latitude;
          const pickupLng = data.pickup.address.coordinate.longitude;
          const destinationLat = data.destination.address.coordinate.latitude;
          const destinationLng = data.destination.address.coordinate.longitude;

          this.mapCenter = {
            lat: (pickupLat + destinationLat) / 2,
            lng: (pickupLng + destinationLng) / 2,
          };

          this.origin = {
            lat: parseFloat(pickupLat),
            lng: parseFloat(pickupLng),
          };
          this.destination = {
            lat: parseFloat(destinationLat),
            lng: parseFloat(destinationLng),
          };
          
          // Wait for Google Maps to load if not available yet
          if (typeof google === "undefined" || !google.maps) {
            console.warn('Google Maps API not loaded yet, waiting...');
            // Retry after a short delay
            setTimeout(() => {
              if (typeof google !== "undefined" && google.maps) {
                this.initializeMapDirections(data, responseObj);
              } else {
                console.error('Google Maps API failed to load');
                this.$vs.loading.close();
              }
            }, 500);
            return;
          }
          
          this.initializeMapDirections(data, responseObj);
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.error("Error fetching ride details:", error);
        });
    },
    
    initializeMapDirections(data, responseObj) {
      if (typeof google === "undefined" || !google.maps) {
        return;
      }
      
      this.directionsService = new google.maps.DirectionsService();
      this.directionsDisplay = new google.maps.DirectionsRenderer();
      const request = {
        origin: new google.maps.LatLng(
          data.pickup.address.coordinate.latitude,
          data.pickup.address.coordinate.longitude
        ),
        destination: new google.maps.LatLng(
          data.destination.address.coordinate.latitude,
          data.destination.address.coordinate.longitude
        ),
        travelMode: google.maps.TravelMode.DRIVING,
      };
      this.directionsService.route(request, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          this.directionsDisplay.setDirections(result);
          this.directionsDisplay.setMap(this.map);

          if (
            ["dispatched", "arrived", "pickedup"].includes(
              responseObj.booking_status
            )
          ) {
            var vehiclePos = responseObj.vehicleLocation;
                this.setInitialPosition({'lat':vehiclePos.latitude,'lng':vehiclePos.longitude,'heading':0});
                this.setupSocketConnectionForVehicle(this.vehicleId);
                this.route = result.routes[0].overview_path.map((point) => ({
                  lat: point.lat(),
                  lng: point.lng(),
                }));
              } else {
                this.route = result.routes[0].overview_path.map((point) => ({
                  lat: point.lat(),
                  lng: point.lng(),
                }));
              }
            }
          });
          this.setZoomBasedOnDistance();

          const loc = {
            latitude: this.vehiclePosition.lat,
            longitude: this.vehiclePosition.lng,
          }
          this.updateEta(loc);
          this.$vs.loading.close();
    },
    callDriver() {
      window.location.href = "tel:+44"+this.driverInfo.phone;
    },

    setupSocketConnectionForBookingStatus(bookingId) {
      // Ignore if already connected to this booking channel
      if (this.bookingChannelId === bookingId) {
        return;
      }
      this.bookingChannelId = bookingId;
      window.Echo.channel(`booking.${bookingId}`).listen(
        "GeneralBookingEvent",
        (event) => {
            switch (event.change_type) {
             
             // todo in future check modified webhook send change_type as booking_details_modified
              case 'cost_modified':
                   window.location.reload();
              break;
              case 'booking_status':
                  this.updateBookingInfo(event.booking, event.request_payload);
              break;
              case 'payment_status':
                  this.updatePaymentStatus(event.request_payload);
              break;
              case 'booking_details_modified':
                  this.updateBookingDetails(event.request_payload);
              break;

              default:
                break;
            }
        }
      );
    },
    setInitialPosition(initialLocation) {
      this.setVehiclePosition(initialLocation);
    },

    setupSocketConnectionForVehicle(vehicleId) {
      // Ignore if already connected to this vehicle channel or no vehicleId yet
      if (!vehicleId) { return; }
      if (this.vehicleChannelId === vehicleId) { return; }
      this.vehicleChannelId = vehicleId;
      window.Echo.channel(`booking-vehicle.${vehicleId}`).listen(
        "VehiclePositionUpdated",
        (event) => {
          this.vehicleConnectionSetup = true
          const etaReceived = event.estimatedPickupTime;
          // If backend sent ETA/estimatedPickupTime, use it, otherwise compute ETA locally
          if (etaReceived !== undefined && etaReceived !== null && etaReceived !== '') {
            this.bookingInfo.eta = this.ensureMinutes(etaReceived);
          } else {
            // Fall back to client-side ETA calculation WITHOUT external APIs
            if(this.showETA !== false)
              {
                // Prefer Autocab ETA API when configured; fall back to local estimate.
                this.updateEta(event.location);
              }
          }
          
          if (!this.vehiclePosition) {
            this.setVehiclePosition({
              lat: event.location.latitude,
              lng: event.location.longitude,
              heading: event.heading,
            });
          }
          else {
              this.updateVehiclePosition({
                  lat: event.location.latitude,
                  lng: event.location.longitude,
                  heading: event.heading,
              })
          }
        }
      );
    },

    updateEta(location) {
      // Only try Autocab ETA API when enabled & provider is autocab; otherwise use local estimator.
      if (this.provider === "autocab") {
        this.updateEtaFromAutocab(location);
        return;
      }
    },

    updateEtaFromAutocab(location) {
      try {
        if (
          !location ||
          (!location.latitude && !location.lat) ||
          (!location.longitude && !location.lng) ||
          !this.origin
        ) {
          return;
        }

        // simple throttle (7s)
        const now = Date.now();
        if (this.autocabEtaLoading || (now - (this.autocabEtaLastFetchAt || 0) < 7000)) return;

        const fromLat = parseFloat(location.lat || location.latitude);
        const fromLng = parseFloat(location.lng || location.longitude);
        
        if ([fromLat, fromLng].some(v => isNaN(v))) {
          return;
        }

        this.autocabEtaLoading = true;
        this.autocabEtaLastFetchAt = now;

        const data = {
          systemId: this.bookingInfo.systemId,
          bookingId: this.apiBookingId,
          currentLocation: 
            { longitude: fromLng, latitude: fromLat }
          
        }
        calculate_eta(data).then(res => {
          if(res.data.status != 200) {
            return;
          }
          const response = res.data.obj;
          const seconds = response && response.durationSeconds ? response.durationSeconds : null;
          if (seconds !== undefined && seconds !== null) {
            this.bookingInfo.eta = this.formatSecondsToMS(seconds);
          } 
        })
          .catch(err => {
            console.warn("Autocab ETA API failed; falling back to local ETA.", err);
          })
          .finally(() => {
            this.autocabEtaLoading = false;
          });
      } catch (err) {
        console.error("Error computing ETA from Autocab API:", err);
        this.autocabEtaLoading = false;
      }
    },

    formatSecondsToMS(durationSeconds) {
      const total = parseInt(durationSeconds, 10);
      if (!isFinite(total) || total < 0) return "";
      const m = Math.floor(total / 60);
      const s = total % 60;
      return `${m}m ${s}s`;
    },
    updateBookingInfo(booking, requestData) {
      
        if(booking.status == 'complete' || booking.status == 'completed' || booking.status == 'cancelled') {
          this.bookingStatus = booking.status;
          this.leaveChannel('vehiclePosition');
          this.archivedBookingDiv = true;
          this.dispatchedBookingDiv = false;
          this.activeBookingDiv = false;
          this.advancedBookingDiv = false;
          return;
        }
      if(this.provider === 'autocab') {
        this.bookingStatus = booking.status;
          this.bookingInfo.distance = requestData.Distance;
          this.bookingInfo.eta = this.formatTime(
            requestData.PriceComparison.EstimatedTime
          );
          if(booking.driver) {
            this.driverInfo.name = booking.driver.first_name + " " + booking.driver.last_name;
            this.driverInfo.phone = booking.driver.mobile;
            this.driverInfo.rating = booking.driver.rating? booking.driver.rating: 0;
          }
          if(booking.vehicle) {
            this.vehicleId = booking.vehicle.autocab_vehicle_id
            this.carInfo._color = booking.vehicle.colour;
            this.carInfo.numberPlate = booking.vehicle.registration;
            this.carInfo.name = `${booking.vehicle.make || ''} ${booking.vehicle.model || ''}`;
          }

      }
      else if(this.provider === 'infocab') {
        
        if(requestData.data.jobStatus == 'ConfirmPending') {
          this.bookingStatus = 'offered';
        }
        else {
          this.bookingStatus = booking.status;
          this.bookingInfo.distance = booking.distance;
          const etaValue = booking.driver_vehicle_data && booking.driver_vehicle_data.pickupEstimatedTimeMinutes ? booking.driver_vehicle_data.pickupEstimatedTimeMinutes : 0;
          this.bookingInfo.eta = this.ensureMinutes(etaValue);
          if(booking.driver) {
            this.driverInfo.name = booking.driver_vehicle_data.driverFirstName + " " + booking.driver_vehicle_data.driverLastName;
            this.driverInfo.phone = booking.driver_vehicle_data.driverMobile;
            this.driverInfo.rating = booking.driver.rating? booking.driver.rating: 0;

          }
          if(booking.vehicle) {
            this.vehicleId = booking.driver_vehicle_data.vehicleId
            this.carInfo._color = booking.driver_vehicle_data.color;
            this.carInfo.numberPlate = booking.driver_vehicle_data.registrationNumber;
            this.carInfo.name = `${booking.driver_vehicle_data.make || ''} ${booking.driver_vehicle_data.model || ''}`;
          }
        }

       
      }
    },
    updatePaymentStatus(paymentData) {
      if(this.provider === 'infocab') {
        // console.log("Payment status update received:", paymentData);
      
      // Update payment status based on the received data
        if (paymentData.paymentStatus) {
          // Use Vue.set to ensure reactivity
          this.$set(this.bookingInfo, 'paymentStatus', this.capitalizeFirstLetter(paymentData.paymentStatus));
          this.$set(this.bookingInfo, 'paymentType', 'CCPaid');
          
          // Show notification to user about payment status change
          this.$vs.notify({
            title: "Payment Status Updated",
            text: `Payment status changed to: ${this.bookingInfo.paymentStatus}`,
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
          });
        }
      }
      else if(this.provider === 'autocab') {
        
        alert('autocab payment status update');
       }
       else {
         alert('other payment status update');
       }
     
    },

    updateBookingDetails(bookingData) {
      // console.log("Booking details update received:", bookingData);
      
      // Validate that bookingData is an object
      if (!bookingData || typeof bookingData !== 'object' || Array.isArray(bookingData)) {
        console.error("Invalid booking data format:", bookingData);
        return;
      }

      if (this.provider === 'infocab') {
        // Update booking information based on the received data
        if (bookingData.status) {
          this.bookingStatus = bookingData.status;
        }

        if (bookingData.pickup) {
          this.$set(this.bookingInfo, 'pickup', bookingData.pickup);
        }

        if (bookingData.destination) {
          this.$set(this.bookingInfo, 'destination', bookingData.destination);
        }

        if (bookingData.price !== undefined && bookingData.price !== null) {
          this.$set(this.bookingInfo, 'price', bookingData.price);
        }

        if (bookingData.distance !== undefined && bookingData.distance !== null) {
          this.$set(this.bookingInfo, 'distance', bookingData.distance);
        }

        if (bookingData.eta) {
          this.$set(this.bookingInfo, 'eta', this.formatTime(bookingData.eta));
        }

        if (bookingData.bookedAtTime) {
          this.$set(this.bookingInfo, 'bookedAtTime', bookingData.bookedAtTime);
        }

        if (bookingData.pickupDateTime) {
          this.$set(this.bookingInfo, 'pickupDateTime', bookingData.pickupDateTime);
        }

        if (bookingData.paymentType) {
          this.$set(this.bookingInfo, 'paymentType', bookingData.paymentType);
        }

        if (bookingData.paymentStatus) {
          if(bookingData.paymentType == 'Account') {
            this.$set(this.bookingInfo, 'paymentStatus', 'Paid');
          }
          else {
            this.$set(this.bookingInfo, 'paymentStatus', this.capitalizeFirstLetter(bookingData.paymentStatus));
          }
          this.$set(this.bookingInfo, 'paymentStatus', this.capitalizeFirstLetter(bookingData.paymentStatus));
        }

        // Update pickup and destination locations if coordinates are provided
        if (bookingData.pickupCoordinates && this.origin) {
          this.$set(this.origin, 'lat', parseFloat(bookingData.pickupCoordinates.latitude));
          this.$set(this.origin, 'lng', parseFloat(bookingData.pickupCoordinates.longitude));
        }

        if (bookingData.destinationCoordinates && this.destination) {
          this.$set(this.destination, 'lat', parseFloat(bookingData.destinationCoordinates.latitude));
          this.$set(this.destination, 'lng', parseFloat(bookingData.destinationCoordinates.longitude));
        }

        // Show notification to user about booking details update
        this.$vs.notify({
          title: "Booking Updated",
          text: "Your booking details have been updated",
          iconPack: "feather",
          icon: "icon-info",
          color: "info",
        });

        // Update the map if coordinates changed
        if ((bookingData.pickupCoordinates && this.origin) || (bookingData.destinationCoordinates && this.destination)) {
          this.setZoomBasedOnDistance();

          // Redraw the route if both origin and destination are set
          if (this.directionsService && this.origin && this.destination && typeof google !== "undefined" && google.maps) {
            const request = {
              origin: new google.maps.LatLng(this.origin.lat, this.origin.lng),
              destination: new google.maps.LatLng(this.destination.lat, this.destination.lng),
              travelMode: google.maps.TravelMode.DRIVING,
            };

            this.directionsService.route(request, (result, status) => {
              if (status === google.maps.DirectionsStatus.OK) {
                this.directionsDisplay.setDirections(result);
                this.directionsDisplay.setMap(this.map);

                this.route = result.routes[0].overview_path.map((point) => ({
                  lat: point.lat(),
                  lng: point.lng(),
                }));
              }
            });
          }
        }
      }
      else if (this.provider === 'autocab') {
        // console.log("Booking details update received:", bookingData);
      }
      else {
        // console.log("Booking details update received:", bookingData);
      }


    },

    updateVehiclePosition(location) {
      // Normalize location format to lat/lng if it comes as latitude/longitude
      const normalizedLocation = {
        lat: location.lat || location.latitude,
        lng: location.lng || location.longitude,
        heading: location.heading || 0
      };
      
      this.newVehiclePositionDestination = normalizedLocation;
      this.mapCenter = normalizedLocation;
      this.moveCar();
    },
    moveCar() {
       if (!this.newVehiclePositionDestination) return;
      // Reset the step counter and calculate deltas
       this.i = 0;

      this.a = (this.newVehiclePositionDestination.lat - this.vehiclePosition.lat) / this.numDeltas;
      this.b = (this.newVehiclePositionDestination.lng - this.vehiclePosition.lng) / this.numDeltas;

      this.animateMarker(); // Start animating towards the destination
    },
    animateMarker() {

       if (this.i < this.numDeltas) {
        // Calculate the next position
        this.vehiclePosition = {
          lat: this.vehiclePosition.lat+this.a,
          lng: this.vehiclePosition.lng+this.b,
        };

 // Center the map on the car as it moves
        this.mapCenter = this.vehiclePosition;
        //  const angle = Math.atan2(this.b, this.a) * (180 / Math.PI);

        // // Update the icon with the new rotation angle
        // this.currentIcon = {
        //   ...this.currentIcon, // Spread existing properties
        //   rotation: angle,
        // };

        // this.testFunc();

        // Adjust zoom based on some criteria (optional)
        this.adjustZoom();
        this.i++;
        setTimeout(this.animateMarker, this.delay);
      } else {
        // Snap to the exact destination after animation completes
        this.vehiclePosition = { ...this.newVehiclePositionDestination };
      }

    },
    adjustZoom() {
      // Example logic to adjust zoom based on movement
      const distance = this.calculateDistance(this.vehiclePosition, this.newVehiclePositionDestination);

      // Adjust zoom level based on distance (use your criteria)
      if (distance > 0.1) {
        this.mapZoom = 12; // Zoom out if moving over a long distance
      } else {
        this.mapZoom = 15; // Default zoom level for close-up
      }
    },
    calculateDistance(pos1, pos2) {
      if (!pos1 || !pos2) return 0;

      const R = 6371; // Radius of Earth in kilometers
      const dLat = (pos2.lat - pos1.lat) * (Math.PI / 180);
      const dLng = (pos2.lng - pos1.lng) * (Math.PI / 180);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(pos1.lat * (Math.PI / 180)) * Math.cos(pos2.lat * (Math.PI / 180)) *
                Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // Distance in kilometers
    },

    capitalizeFirstLetter(string) {
      if(string == null || string == undefined || string == '')
        return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    // async shareContent() {
    //   // Check if Web Share API is supported
    //   if (navigator.share) {
    //     try {
    //       // Define the content to share
    //       const shareData = {
    //         title: "Check out this page!",
    //         text: "I found something interesting here:",
    //         url: window.location.href, // Current page URL
    //       };

    //       // Trigger the share dialog
    //       await navigator.share(shareData);
    //       console.log("Successfully shared");
    //     } catch (err) {
    //       console.error("Error sharing:", err);
    //     }
    //   } else {
    //     // Fallback for browsers that don't support Web Share API
    //     this.copyUrlToClipboard();
    //   }
    // },
    //  copyUrlToClipboard1() {
    //   const text = encodeURIComponent("Check out this driver! " + window.location.href);
    //   const whatsappUrl = `https://wa.me/?text=${text}`;
    //   window.open(whatsappUrl, "_blank");
    // },
    // // Fallback: Copy the URL to the clipboard
    // copyUrlToClipboard() {
    //   const url = window.location.href;
    //   navigator.clipboard
    //     .writeText(url)
    //     .then(() => {
    //       alert(
    //         "The URL has been copied to your clipboard. You can paste it anywhere to share."
    //       );
    //     })
    //     .catch((err) => {
    //       console.error("Error copying to clipboard:", err);
    //       alert("Unable to copy the URL. Please manually share the page.");
    //     });
    // },


    testFunc() {
      if (typeof google === "undefined" || !google.maps || !this.directionsService) {
        return;
      }
      
      const request1 = {
            origin: new google.maps.LatLng(
              this.vehiclePosition.lat,
              this.vehiclePosition.lng
            ),
            destination: new google.maps.LatLng(
              this.destination.lat,
              this.destination.lng
            ),
            travelMode: google.maps.TravelMode.DRIVING,
          };
          this.directionsService.route(request1, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK) {
              this.directionsDisplay.setDirections(result);
              this.directionsDisplay.setMap(this.map);
                this.route = result.routes[0].overview_path.map((point) => ({
                  lat: point.lat(),
                  lng: point.lng(),
                }));
            }
          });
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

* {
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: #0a0a0b;
}

.searching-box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.searching-text {
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 21.6px;
}
.search-icon-img {
  width: 21.208px;
  height: 21.207px;
}
.page-container {
  background-color: #0d2047;
  padding: 60px 100px 100px 100px;
  display: flex;
  flex-direction: column;
  height: 100vh; /* Full viewport height */
  box-sizing: border-box; /* Include padding in width/height calculations */
  align-items: stretch;
}

.nudge-pay-header {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.nudge-pay-header img {
  width: 217px;
  height: 70px;
}

.booking-details-container {
  display: flex;
  background-color: #fff;
  border-radius: 24px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.booking-details-card {
  width: 55%;
}

.booking-status-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 5px;
  align-items: center;
  align-self: stretch;
}

.booking-title {
  font-size: 24px;
  font-weight: 600;
}

.booking-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background-color: #f5f7fb;
  padding: 14px 28px 14px 28px;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 500;
}

.driver-info {
  display: flex;
  align-items: center;
}

.driver-avatar {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.driver-details {
  display: flex;
  flex-direction: column;
}

.driver-name {
  font-weight: 600;
}

.driver-rating {
  display: flex;
  align-items: center;
  width: 75px;
  height: 27px;
  border-radius: 24px;
  background-color: #ffffff;
  padding: 4px 6px 4px 6px;
}

.driver-actions {
  display: flex;
  gap: 10px;
}
.contact-button,
.share-button {
  background-color: #51d07d;
  border: none;
  border-radius: 50%;
  width: 31px;
  height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.share-button {
  background-color: #000;
}

.star-icon {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.accepted-button {
  background-color: #79e864;
  border: none;
  color: #0a0a0b;
  border-radius: 28px;
  padding: 10px 28px 10px 28px;
  font-weight: 600;
  font-size: 18px;
  max-width: fit-content;

}
.advance-button {
  background-color: #f0d84f;
  border: none;
  color: #0a0a0b;
  border-radius: 28px;
  padding: 10px 28px 10px 28px;
  font-weight: 600;
  font-size: 18px;
  max-width: fit-content;
}
.archived-button {
  background-color: #e18d8d;
  border: none;
  color: #0a0a0b;
  border-radius: 28px;
  padding: 10px 28px 10px 28px;
  font-weight: 600;
  font-size: 18px;
  max-width: fit-content;

}
.searching-status-btn {
  background-color: #f0aa4f;
  border: none;
  color: #0a0a0b;
  border-radius: 28px;
  padding: 10px 28px 10px 28px;
  font-weight: 600;
  font-size: 18px;
  max-width: fit-content;

}

.vehicle-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fb;
  padding: 14px 28px 14px 28px;
  border-radius: 14px;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 500;
}

.license-plate {
  background-color: #f0d84f;
  padding: 4px 6px 4px 6px;
  font-weight: bold;
}

.ride-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fb;
  padding: 14px 28px 14px 28px;
  border-radius: 14px;
  margin-bottom: 15px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #726c6c;
}

.eta,
.distance,
.price {
  text-align: center;
}

.ride-info-heads {
  color: #726c6c;
}

.locations {
  margin-top: 20px;
}

.location-row {
  display: flex;
  align-items: center;
  background-color: #f5f7fb;
  padding: 14px 28px 14px 28px;
  border-radius: 14px;
  margin-bottom: 10px;
  font-size: 16px;
}

.pickup-row {
  height: auto;
  padding: 10px;
  border-radius: 8px;
  background-color: #ffffff;
   display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.dropoff-row {
  height: auto;
  padding: 10px;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.location-icon {
  margin-right: 10px;
}

.location-icon-img {
  width: 12px;
  height: 12px;
}

.location-type {
  color: #726c6c;
  font-weight: 500;
  margin-right: 5px;
}

.separator {
  color: #726c6c;
  margin-right: 5px;
}

.location-address {
  font-weight: 400;
  color: #0a0a0b;
  flex: 1;
  word-wrap: break-word;
}

.map-container {
  width: 40%;
  padding-left: 20px;
  border-radius: 10px;
}
.map-container .vue-map-container .vue-map {
  border-radius: 15px !important;
  -webkit-border-radius: 6px;
}

/* Polished marker label styles */
::v-deep .pickup-marker-label,
::v-deep .dropoff-marker-label {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  letter-spacing: 0.5px;
  padding: 2px 4px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
}
.payment-color {
  color: #4c8a26;
  font-weight: 700;
}

.feature-disabled-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
}

.feature-disabled-card {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 24px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feature-disabled-img {
  width: 100%;
  max-width: 280px;
  height: auto;
  margin-bottom: 20px;
}

.feature-disabled-title {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 12px;
}

.feature-disabled-text {
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  max-width: 360px;
}

/* Responsive Styles */
@media (max-width: 786px) {
  .page-container {
    overflow-y: auto;
    padding: 10px;
    /* Reduced padding for smaller screens */
    box-sizing: border-box;
  }
  .nudge-pay-header {
    justify-content: center;

    /* Reduced size for mobile */
  }
  .feature-disabled-card {
    padding: 16px 12px;
  }
  .feature-disabled-img {
    max-width: 180px;
    margin-bottom: 16px;
  }
  .feature-disabled-title {
    font-size: 22px;
    margin-bottom: 8px;
  }
  .feature-disabled-text {
    font-size: 14px;
    padding: 0 8px;
  }
  .booking-details-container {
    align-items: center;
    /* Center content on smaller screens */
    flex-direction: column;
    /* Stacks content on smaller screens */
    align-items: center;

    /* Center content on smaller screens */
  }
  .booking-details-card {
    width: 100%;
    /* Full width on smaller screens */
  }
  .booking-title {
    font-size: 15px;
    /* Adjusted for mobile */
    font-weight: 600;
  }
  .booking-details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    background-color: #f5f7fb;
    padding: 5px 10px;
    /* Reduced padding for mobile */
    border-radius: 14px;
    font-size: 14px;
    /* Adjusted for mobile */
  }
  .driver-avatar {
    width: 40px;
    /* Adjusted size for mobile */
    height: 40px;
    margin-right: 10px;
  }
  .driver-rating {
    display: flex;
    align-items: center;
    width: 65px;
    /* Adjusted for mobile */
    height: 24px;
    border-radius: 24px;
    background-color: #ffffff;
    padding: 4px 6px;
  }
  .star-icon {
    width: 12px;
    /* Adjusted size for mobile */
    height: 12px;
    margin-right: 5px;
  }
  .accepted-button {
    font-size: 14px;
    /* Adjusted for mobile */
    padding: 5px 10px;
    /* Reduced padding for mobile */

    margin-top: -5px;
  }
  .advance-button {
    font-size: 14px;
    /* Adjusted for mobile */
    padding: 10px 18px;
    /* Reduced padding for mobile */

    margin-top: -5px;
  }
  .vehicle-info-row {
    padding: 10px 20px;
    /* Reduced padding for mobile */
    font-size: 14px;
    /* Adjusted for mobile */
  }
  .license-plate {
    padding: 4px 6px;
  }
  .ride-info-row {
    padding: 10px 20px;
    /* Reduced padding for mobile */
    font-size: 14px;
    /* Adjusted for mobile */
  }
  .location-row {
    font-size: 14px;
    /* Adjusted for mobile */
    padding: 10px 10px;
    /* Reduced padding for mobile */
  }
  .location-icon-img {
    margin-left: 10px;
    padding-right: 3px;
  }
  .map-container {
    width: 100%;
    padding: 0;
    display: flex;

    /* Map takes full width on mobile */
  }
  .map-container img {
    width: 100%;
    height: 280px;
    border-radius: 10px;
  }
  .pickup-row {
    padding: 8px 4px 8px 8px;
  }
  .dropoff-row {
    padding: 8px 4px 8px 8px;
  }


}
</style>
